module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3ibfQ"))).then(() => parcelRequire('f4eak'));